import merge from 'lodash/merge';
//
import { button } from './components/button';
import { textField } from './components/textfield';
import { switches } from './components/switch';
import { list } from './components/list';
import { typography } from './components/typography';
import { dataGrid } from './components/data-grid';
import { chip } from './components/chip';
import { breadcrumbs } from './components/breadcrumbs';
import { select } from './components/select';
import { tabs } from './components/tabs';
import { accordion } from './components/accordion';
import { datePicker } from './components/date-picker';
import { autocomplete } from './components/autocomplete';
import { dialog } from './components/dialog';
// ----------------------------------------------------------------------
export function componentsOverrides(theme) {
    const components = merge(button(theme), textField(theme), switches(theme), list(theme), typography(theme), dataGrid(theme), chip(theme), breadcrumbs(theme), select(theme), tabs(theme), accordion(theme), datePicker(theme), autocomplete(theme), dialog(theme));
    return components;
}
